import React from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';

interface ErrorDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  closeLabel?: string;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
  open,
  title = 'Error',
  message,
  onClose,
  closeLabel = 'Close',
}) => {
  if (!open) return null;

  return (
    <div style={overlayStyle}>
      <div style={dialogStyle} role="alertdialog" aria-modal="true" aria-labelledby="error-dialog-title" aria-describedby="error-dialog-message">
        <div style={headerStyle}>
          <span style={iconStyle}>&#9888;</span>
          <h3 id="error-dialog-title" style={{ margin: 0, color: '#c0392b' }}>{title}</h3>
        </div>
        <p id="error-dialog-message" style={{ margin: '12px 0 20px', color: '#333' }}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>{closeLabel}</Button>
        </div>
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const dialogStyle: React.CSSProperties = {
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '320px',
  maxWidth: '480px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
};

const headerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

const iconStyle: React.CSSProperties = {
  fontSize: '20px',
  color: '#c0392b',
};

export default ErrorDialog;
